module.exports = __webpack_public_path__ + "media/images/sovrn_logo-613bc4e5cb0f3a98bdd8b3f32daee9a4.jpg";